import { useEffect } from 'react';

/**
 * Refresh label search highlights whenever the active search inputs change.
 */
const useSearchHighlightUpdates = (
    onHighlightsChanged: () => void,
    filterQuery: string | undefined,
    labelScopeId?: string | null,
) => {
    useEffect(() => {
        onHighlightsChanged();
    }, [filterQuery, labelScopeId, onHighlightsChanged]);
};

export default useSearchHighlightUpdates;
